import React, { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

interface PageTitleContextType {
  title: ReactNode
  setTitle: (title: ReactNode) => void
}

const PageTitleContext = createContext<PageTitleContextType | undefined>(undefined)

export const PageTitleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState<ReactNode>('')

  return (
    <PageTitleContext.Provider value={{ title, setTitle }}>
      {children}
    </PageTitleContext.Provider>
  )
}

export const usePageTitle = () => {
  const context = useContext(PageTitleContext)
  if (!context) throw new Error('usePageTitle must be used within a PageTitleProvider')
  return context
}